import styled from 'styled-components'

export const StyledMusicPlayerArtistName = styled.h3`
  font-family: ${({ theme }) => theme.fontFamily.secondary};
  font-size: ${({ theme }) => theme.fontSize.sm};
  padding-bottom: ${({ theme }) => theme.spacing(3)};
  color: ${({ theme }) => theme.palette.common.white};
`
